import moment from 'moment';

export function roundDecimal(decimal) {
  if (decimal == null) {
    return undefined;
  }
  return Math.round(decimal * 10) / 10;
}

export function durationBetween(start, stop) {
  if (!start || !stop) {
    return '';
  }
  const ms = moment(stop).diff(moment(start));
  const d = moment.duration(ms);

  return `${Math.floor(d.asDays())} ${moment.utc(ms).format('HH:mm:ss')}`;
}

